/* eslint react/no-unused-prop-types: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ValutaFilter from '@eika-infrastruktur/ui-valuta-filter';
import Input from './input';

class ValutaInput extends Component {

    static propTypes = {
        label: PropTypes.string,
        name: PropTypes.string,
        tooltipText: PropTypes.string,
        modalHelpBody: PropTypes.element,
        modalHelpHeader: PropTypes.string,
        infoLinkLabel: PropTypes.string,
        infoLinkText: PropTypes.string,
        errorText: PropTypes.string,
        min: PropTypes.number,
        max: PropTypes.number.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        type: PropTypes.string
    };

    static defaultProps = {
        type: 'tel'
    };

    constructor(props) {
        super(props);
        const formattedValue = props.value
            ? ValutaFilter(Number(props.value), ' ', 0)
            : '';
        this.state = {
            formattedValue,
            value: formattedValue
        };
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onBlur(event) {
        const { value } = this.state;
        const formattedValue = value
                ? ValutaFilter(Number(value.toString().replace(/ /g, '')), ' ', 0)
                : value;
        this.setState({
            ...this.state,
            value: formattedValue
        });

        if (this.props.onBlur) {
            this.props.onBlur(event);
        }
    }

    onFocus(event) {
        const { value } = this.state;
        const unformattedValue = value && value.toString().replace(/ /g, '');
        this.setState({
            ...this.state,
            value: unformattedValue
        });

        if (this.props.onFocus) {
            this.props.onFocus(event);
        }
    }

    componentWillReceiveProps(props) {
        if (document.activeElement !== this.inputElement) {

            const formattedValue = props.value
                ? ValutaFilter(Number(props.value.toString().replace(/ /g, '')), ' ', 0)
                : props.value;
            this.setState({
                ...this.state,
                value: formattedValue
            });
        }
    }

    onChange(event) {
        const { value } = event.target;
        if ((!isNaN(Number(value.toString().replace(/ /g, ''))) || !value)
            && (this.props.max && Number(value.toString().replace(/ /g, '')) < +this.props.max + 1)) {
            this.setState({
                ...this.state,
                value
            });

            if (this.props.onChange) {
                this.props.onChange(event);
            }
        }
    }

    render() {
        const {
            label,
            type,
            name,
            tooltipText,
            modalHelpBody,
            modalHelpHeader,
            infoLinkLabel,
            infoLinkText,
            errorText,
            onKeyUp,
            ...rest
        } = this.props;

        return (
            <Input
                {...rest}
                // eslint-disable-next-line no-return-assign
                inputRef={el => this.inputElement = el}
                label={label}
                type={type}
                name={name}
                value={this.state.value}
                tooltipText={tooltipText}
                modalHelpBody={modalHelpBody}
                modalHelpHeader={modalHelpHeader}
                infoLinkLabel={infoLinkLabel}
                infoLinkText={infoLinkText}
                errorText={errorText}
                onChange={this.onChange}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
                onKeyUp={onKeyUp}
            />
        );
    }

}

export default ValutaInput;
